import React from "react";
import { LayoutGridIcon } from "lucide-react";
import "./ConnectSection.scss";
import Message from "../../../../i18n/Message";
import { AppClient } from "./appClients";
import AppItem from "./AppItem";
import { useUiMode } from "../context/UiModeContext";
import { useIntl } from "react-intl";
import label from "../../../../i18n/label";
import { useState } from "react";
import PlaygroundAuthType from "../../playgroundAuthType";
import replaceUrlParameters from "./urlParameterReplacer";

const ConnectSection = ({ playground }) => {
  const intl = useIntl();
  const { uiMode } = useUiMode();
  const [bearerToken, setBearerToken] = useState("");
  const [urlParams, setUrlParams] = useState({});

  let mcpServerUrl = playground.mcpServerUrl;
  if (Object.keys(urlParams).length > 0) {
    mcpServerUrl = replaceUrlParameters(mcpServerUrl, urlParams);
  }
  return (
    <div className={`connect_section ${uiMode.toLowerCase()}_mode`}>
      <h2>
        <Message id="widget_connect_title" />
      </h2>
      <div className="top_navigation">
        <div className="nav_item selected">
          <LayoutGridIcon />
          <Message id="widget_menu_connect_apps" />
        </div>
        {/* <div className="nav_item">
          <BracesIcon />
          <Message id="widget_menu_connect_code" />
        </div> */}
      </div>
      {playground.authType === PlaygroundAuthType.BEARER_TOKEN && (
        <div className="auth_token_container">
          <div className="auth_token_help">
            <Message id="widget_auth_token_help" />
          </div>
          <input
            className="form-control"
            type="text"
            placeholder={label(intl, "widget_auth_token_placeholder")}
            value={bearerToken}
            onChange={(e) => setBearerToken(e.target.value)}
            autoComplete="off"
          />
        </div>
      )}
      {playground.authType === PlaygroundAuthType.OAUTH && (
        <div className="auth_token_container">
          <div className="auth_token_help">
            <Message id="connect_oauth_note" />
          </div>
        </div>
      )}
      {playground.urlParams && JSON.parse(playground.urlParams).length > 0 && (
        <div className="auth_url_param_container">
          <div className="auth_url_params_help">
            <Message id="widget_auth_url_params_help" />
          </div>
          <div className="auth_url_params_list">
            {JSON.parse(playground.urlParams).map((param) => (
              <div key={param} className="auth_url_param_item">
                <div className="auth_url_param_name">{param}</div>
                <input
                  className="form-control"
                  type="text"
                  placeholder={label(intl, "widget_auth_url_param_placeholder")}
                  value={urlParams[param]}
                  onChange={(e) =>
                    setUrlParams({ ...urlParams, [param]: e.target.value })
                  }
                />
              </div>
            ))}
          </div>
        </div>
      )}
      <div className="app_list">
        {Object.keys(AppClient).map((app) => {
          return (
            <AppItem
              key={app}
              app={app}
              playground={playground}
              uiMode={uiMode}
              bearerToken={bearerToken}
              mcpServerUrl={mcpServerUrl}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ConnectSection;
